
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Pourquoi confier son logo à une agence plutôt qu’à une IA | ALEO",
    description:
      "L’IA crée vite, mais l’agence crée juste. Découvrez pourquoi confier la création de votre logo à une agence de communication comme ALEO garantit originalité, stratégie et accompagnement sur-mesure.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
